<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23 24a1 1 0 0 1-1-1 6 6 0 0 0-6-6h-5.83v1.59A2 2 0 0 1 6.76 20L.88 14.12a3 3 0 0 1 0-4.24L6.76 4a2 2 0 0 1 3.41 1.41V7H15a9 9 0 0 1 9 9v7a1 1 0 0 1-1 1M8.17 5.41 2.29 11.3a1 1 0 0 0 0 1.42l5.88 5.88V16a1 1 0 0 1 1-1H16a8 8 0 0 1 6 2.71V16a7 7 0 0 0-7-7H9.17a1 1 0 0 1-1-1Z"/></svg>
</template>
